<template>
    <div class="bg-white">

        <div class="shadow-lg rounded-lg flex flex-col border-t-4 border-blue-dark">

            <div class="overflow-auto">

                <div class="table bg-white min-w-full" v-if="!swap">

                    <div class="table-row bg-grey-light uppercase font-semibold text-lg border-b">
                        <div class="border-b table-cell p-2"></div>
                        <div class="table-cell text-grey-darker whitespace-no-wrap text-center"
                             v-for="(row, key) in rows">
                            <a class="border-b px-2 py-4 block cursor-pointer hover:bg-blue-lighter"
                               @click="highlightRow = highlightRow === key ? false : key"
                               :class="{'bg-blue-lighter': key === highlightRow}">
                                {{ row.name | limit }}
                            </a>
                        </div>
                    </div>

                    <div class="table-row hover:bg-yellow"
                         v-for="(time, index) in times"
                         :class="{'bg-grey-lighter': isDarker(index)}"
                    >
                        <div class=" border-r table-cell p-2 text-grey-darker whitespace-no-wrap">
                            {{ time }}
                        </div>
                        <div
                                class=" table-cell text-right text-sm p-2"
                                v-for="(row, key) in rows"
                                :class="{'bg-blue-lightest': key === highlightRow}">
                            {{ getValue(row, time) }}
                        </div>
                    </div>

                </div>

                <div class="table bg-white min-w-full" v-if="swap">
                    <div class="table-row">
                        <div class="table-cell p-2"></div>
                        <div class="table-cell p-2 text-grey-darker whitespace-no-wrap" v-for="time in times">
                            {{ time }}
                        </div>
                    </div>
                    <div class="table-row"
                         v-for="(row,key) in rows"
                         v-bind:class="{'bg-grey-lighter': isDarker(key), 'bg-blue-lightest': key === highlightRow}"
                    >
                        <div
                                class="table-cell bg-grey-lighter text-grey-darker whitespace-no-wrap"
                                :class="{'bg-blue-lightest': key === highlightRow}"
                        >
                            <a class="p-2 block clickable" @click="highlightRow = highlightRow === key ? false : key"
                               :class="{'bg-blue-lighter': key === highlightRow}">
                                {{ row.name | limit }}
                            </a>
                        </div>
                        <div class="table-cell text-right text-sm p-2" v-for="time in times">
                            {{ getValue(row, time) }}
                        </div>
                    </div>
                </div>


            </div>

            <div class="p-2">
                <!--<a class="btn inline-block" @click="exportChart('image/svg+xml')">
                    <i class="fa fa-download"></i> SVG
                </a>
                <a class="btn inline-block" @click="exportChart('image/png')">
                    <i class="fa fa-download"></i> PNG
                </a>-->
                <a class="btn inline-block" href="#/export">
                    <i class="fa fa-download"></i> Export Data
                </a>
            </div>

        </div>


    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                //swap: false,
                highlightRow: false,
                highlightCeil: false,
            };
        },

        filters: {
            limit(string) {
                if (string.length < 15) {
                    return string;
                }

                return string.substring(0, 13) + '..';
            }
        },

        computed: {
            swap() {
                return this.$store.state.tableSwap;
            },
            times() {
                return this.$store.getters.times;
            },
            rows() {
                return this.$store.getters.rows;
            }
        },

        methods: {
            isDarker(index) {
                return parseInt(index / 3) % 2 === 0;
            },
            getValue(row, time) {
                const result = row.data.find(function (item) {
                    return item.time === time;
                });
                if (result === undefined || result.value === null) {
                    return '-';
                }

                return result.value;
            }
        },
    }
</script>
